import { styled } from "@mui/material";

import { formatUTCFullDate, formatUTCTime } from "utils";

export function formatDateToRecord(createdAt: string) {
  const fullDate = formatUTCFullDate(createdAt);
  const utcTime = `${formatUTCTime(createdAt, true)} UTC`;

  return (
    <span>
      {fullDate}
      <DotWrapper sx={{ mx: 1 }}>•</DotWrapper>
      {utcTime}
    </span>
  );
}

const DotWrapper = styled("span")({});
